const UtensilsSmallIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Fork */}
      <path d="M11 3 L11 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M8 3 L8 9 Q8 11, 10 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
      <path d="M14 3 L14 9 Q14 11, 12 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
      <path d="M11 11 L11 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      
      {/* Knife */}
      <path d="M21 3 L21 14 Q21 16, 22.5 16 L22.5 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none"/>
      <path d="M19 3 Q21 6, 21 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
    </svg>
  );
};

export default UtensilsSmallIcon;

